import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CardType } from '../../types/index';
import { CardStyled, CardDescription } from '../../styles/index';

interface DraggableCardProps {
  card: CardType;
  columnId: number;
  boardId: number;
  onOpenCard: () => void;
  isWarning?: boolean;
}

function DraggableCard({ card, columnId, onOpenCard, isWarning }: DraggableCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: String(card.id),
    data: { id: card.id, column_id: columnId, position: card.position },
  });

  const draggableStyle = transform
    ? {
      transform: `translate(${transform.x}px, ${transform.y}px)`,
      transition: transition || undefined,
    }
    : undefined;

  return (
    <div
      ref={setNodeRef}
      style={{
        ...draggableStyle,
        touchAction: 'none',
      }}
      {...attributes}
      {...listeners}
    >
      <CardStyled
        onClick={onOpenCard}
        $isGhost={isDragging}
        $priority={card.priority}
        $warning={!!isWarning}
      >
        <CardDescription>{card.description || 'Sem descrição'}</CardDescription>
      </CardStyled>
    </div>
  );
}

export default DraggableCard;
